export const START_IMAGE_CROP = 'START_IMAGE_CROP';
export const LOAD_IMAGE_CROP = 'LOAD_IMAGE_CROP';
export const CANCEL_IMAGE_CROP = 'CANCEL_IMAGE_CROP';
export const CONFIRM_IMAGE_CROP = 'CONFIRM_IMAGE_CROP';
export const CONFIRM_IMAGE_CROP_SUCCESS = 'CONFIRM_IMAGE_CROP_SUCCESS';
export const CONFIRM_IMAGE_CROP_FAILED = 'CONFIRM_IMAGE_CROP_FAILED';
export const SET_CROP_IMAGE = 'SET_CROP_IMAGE';
export const SET_CROP_SHAPE = 'SET_CROP_SHAPE';
export const SHOW_CROP_WARNING = 'SHOW_CROP_WARNING';
export const CONFIRM_CROP_WARNING = 'CONFIRM_CROP_WARNING';
export const CANCEL_CROP_WARNING = 'CANCEL_CROP_WARNING';

export const startImageCrop = ({ scribeId, elementId, sceneId }) => ({
  type: START_IMAGE_CROP,
  scribeId,
  elementId,
  sceneId
});

export const loadImageCrop = ({ scribeId, elementId, sceneId, imageUrl, transforms = {} }) => ({
  type: LOAD_IMAGE_CROP,
  scribeId,
  elementId,
  sceneId,
  imageUrl,
  transforms
});

export const cancelImageCrop = () => ({
  type: CANCEL_IMAGE_CROP
});

export const confirmImageCrop = () => ({
  type: CONFIRM_IMAGE_CROP
});

export const confirmImageCropSuccess = () => ({
  type: CONFIRM_IMAGE_CROP_SUCCESS
});

export const confirmImageCropFailed = error => ({
  type: CONFIRM_IMAGE_CROP_FAILED,
  error
});

export const setCropImage = crop => ({
  type: SET_CROP_IMAGE,
  crop
});

export const setCropShape = shape => ({
  type: SET_CROP_SHAPE,
  shape
});

export const showCropWarning = () => ({
  type: SHOW_CROP_WARNING
});

export const confirmCropWarning = ({ scribeId, suppressWarning }) => ({
  type: CONFIRM_CROP_WARNING,
  scribeId,
  suppressWarning
});

export const cancelCropWarning = scribeId => ({
  type: CANCEL_CROP_WARNING,
  scribeId
});
